var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { components, tabs } from "./collection-case-info/";
import { namespace } from "vuex-class";
import { Prop } from "vue-property-decorator";
var CollectionExecutionModule = namespace("collection-execution");
var CollectionCaseInfo = /** @class */ (function (_super) {
    __extends(CollectionCaseInfo, _super);
    function CollectionCaseInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabs = tabs;
        return _this;
    }
    Object.defineProperty(CollectionCaseInfo.prototype, "activeName", {
        get: function () {
            return this.caseInfoActiveName;
        },
        set: function (val) {
            this.updateCaseInfoActiveName(val);
        },
        enumerable: false,
        configurable: true
    });
    CollectionCaseInfo.prototype.onClickDetail = function () {
        window.open(this.topInfo.externalLink);
    };
    __decorate([
        CollectionExecutionModule.State
    ], CollectionCaseInfo.prototype, "caseInfoActiveName", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], CollectionCaseInfo.prototype, "updateCaseInfoActiveName", void 0);
    __decorate([
        Prop({ type: Object })
    ], CollectionCaseInfo.prototype, "topInfo", void 0);
    CollectionCaseInfo = __decorate([
        Component({
            components: __assign({}, components)
        })
    ], CollectionCaseInfo);
    return CollectionCaseInfo;
}(Vue));
export default CollectionCaseInfo;
